import React, { useCallback, useEffect, useRef, useState } from 'react';
import { oneriTara, oneriDurum, oneriBekleyenler, oneriGecmis, oneriGeriGetir, oneriSil,
         kararOnayla, kararReddet, kararUygula } from '../../services/reklamApi';
import './Kararlar.css';

// KARARLAR — Reklam Yönetimi'nin karar kutusu (kullanıcı talebi: 2026-09-29).
//
// NEDEN YENİ EKRAN: "Yapay Zeka Önerileri" ekranı iki işi birden yapıyordu — hem karar onayı
// hem video üretim stüdyosu. Kullanıcı: "ben ne isteyeceğimi de bilecek kadar bilmiyorum".
// Karar vermeye gelen kişi prodüksiyon hattında geziniyordu. Bu ekranda SADECE karar var;
// üretim eski ekranda kaldı.
//
// TASARIM KURALLARI (kullanıcının beklentisinden çıkarıldı):
//   1. Başlık PARAYLA başlar — Meta terimiyle değil. "14.000 ₺ boşa gidiyor", "adset_id" değil.
//   2. Her kartta "yapmazsak ne olur" ve "risk" var: bilmeyen biri için karar, doğruluk değil
//      geri alınabilirlik sorusudur.
//   3. En fazla 5 kart açık gelir, gerisi katlanır. 30 kart gösterilirse hiçbirine bakılmaz.
//   4. "Neden böyle diyorsun?" kanıtı açar — öğrenme zorunlu değil, sızarak olur.
//   5. Geçmiş sekmesinde sistemin YANILDIĞI kararlar da görünür; körü körüne güven istenmiyor.
export default function Kararlar() {
  const [sekme, setSekme] = useState('bekleyen');   // bekleyen | gecmis
  const [kartlar, setKartlar] = useState([]);
  const [gecmis, setGecmis] = useState([]);
  const [durum, setDurum] = useState('yukleniyor');
  const [hata, setHata] = useState('');
  const [tarama, setTarama] = useState(null);       // { asama, yuzde }
  const [acikKanit, setAcikKanit] = useState({});
  const [hepsiAcik, setHepsiAcik] = useState(false);
  const [islemde, setIslemde] = useState(null);
  const [bilgi, setBilgi] = useState('');
  const [eskiler, setEskiler] = useState(false);   // Ağustos'taki eski sistem kayıtları

  // Filtre paneli durumu — üç paradigma, aynı anda yalnız biri geçerli (2026-10-02).
  const [fSekme, setFSekme] = useState('is');      // is | yapi | para
  const [fIs, setFIs] = useState('hepsi');         // hepsi | para | kreatif | not
  const [fSube, setFSube] = useState('hepsi');
  const [fHizmet, setFHizmet] = useState('hepsi');
  const [fSeviye, setFSeviye] = useState('hepsi');
  const [fParaEsik, setFParaEsik] = useState(0);
  const zamanlayici = useRef(null);

  const yukle = useCallback(() => {
    setHata('');
    oneriBekleyenler()
      .then(r => { setKartlar(r.data?.kartlar || []); setDurum('hazir'); })
      .catch(e => { setHata(e.response?.data?.hata || e.message); setDurum('hazir'); });
  }, []);

  useEffect(() => { yukle(); }, [yukle]);
  useEffect(() => () => clearInterval(zamanlayici.current), []);

  const gecmisYukle = () => {
    oneriGecmis(90)
      .then(r => setGecmis(r.data?.kayitlar || []))
      .catch(e => setHata(e.response?.data?.hata || e.message));
  };

  // Yanlışlıkla reddedilen öneriyi karar kutusuna geri çağırır (kullanıcı sorusu: 2026-09-29
  // "yanlışlıkla reddedersem ... ona nasıl geri ulaşırım?" — o güne kadar bir yolu yoktu).
  const geriGetir = async (kararId) => {
    setIslemde(kararId); setHata(''); setBilgi('');
    try {
      await oneriGeriGetir(kararId);
      setBilgi('Öneri karar kutusuna geri alındı.');
      gecmisYukle();
      yukle();
    } catch (e) {
      setHata(e.response?.data?.hata || e.message);
    } finally { setIslemde(null); }
  };

  // ARŞİVDEN KALICI SİLME (kullanıcı talebi: 2026-10-02) — "kendi inisiyatifimle silme
  // imkanı da tanı". Geri alınamaz, o yüzden onay soruluyor. Üretimi başlamış kayıtları
  // sunucu zaten reddediyor.
  const arsivdenSil = async (kararId) => {
    if (!window.confirm('Bu kayıt kalıcı olarak silinecek. Geri alınamaz. Emin misin?')) return;
    setIslemde(kararId); setHata(''); setBilgi('');
    try {
      await oneriSil(kararId);
      setGecmis(g => g.filter(x => x.kararId !== kararId));
      setBilgi('Kayıt silindi.');
    } catch (e) {
      setHata(e.response?.data?.hata || e.message);
    } finally { setIslemde(null); }
  };

  // Tarama uzun sürüyor (Meta + 6 klinik veritabanı); ilerleme çubuğu gerçek adımları gösterir.
  const taramaBaslat = () => {
    setHata(''); setBilgi('');
    setTarama({ asama: 'Başlatılıyor...', yuzde: 0 });
    oneriTara(120)
      .then(r => {
        const isId = r.data?.isId;
        zamanlayici.current = setInterval(() => {
          oneriDurum(isId)
            .then(d => {
              const v = d.data;
              setTarama({ asama: v.asama, yuzde: v.yuzde });
              if (v.tamamlandi || v.hata) {
                clearInterval(zamanlayici.current);
                setTarama(null);
                if (v.hata) setHata(v.hata);
                else {
                  // "0 yeni öneri" kullanıcıyı yanılttı (2026-10-02): "hiçbir şey değişmedi mi?"
                  // Tarama mevcut kartları SİLMEZ, TAZELER — rakamlar güncellenir ama yeni satır
                  // açılmaz, o yüzden sayaç 0 der. Artık tazelenen kart sayısı da yazılıyor.
                  const yeni = v.sonuc?.yeniKayit ?? 0;
                  const toplam = v.sonuc?.kartlar?.length ?? 0;
                  setBilgi(yeni > 0
                    ? `Tarama bitti · ${yeni} yeni öneri · toplam ${toplam} kart`
                    : `Tarama bitti · yeni öneri yok, mevcut ${toplam} kart tazelendi (rakamlar güncellendi)`);
                  yukle();
                }
              }
            })
            .catch(() => {});
        }, 2000);
      })
      .catch(e => { setTarama(null); setHata(e.response?.data?.hata || e.message); });
  };

  // Kabul iki farklı şey yapabilir (kullanıcı sorusu: 2026-09-29 "KABUL dersem ne oluyor?"):
  //   metaYazar = true  → onayla + Meta'ya uygula (durdurma / bütçe / durdur-ve-aktar)
  //   metaYazar = false → yalnızca onayla; Meta'ya HİÇBİR ŞEY yazılmaz, iş emri açılır
  //                       (yeni kreatif üretimi İçerik Stüdyosu'na, gözden geçirme listeye)
  // Eskiden hepsinde "uygula" çağrılıyordu ve iş emri türlerinde kullanıcı kırmızı hata görüyordu.
  const kabulEt = async (kararId, kart) => {
    setIslemde(kararId); setHata(''); setBilgi('');
    try {
      await kararOnayla(kararId);
      if (kart.metaYazar) {
        await kararUygula(kararId);
        setBilgi('Meta\'ya uygulandı. Geçmiş sekmesinden geri alabilirsin.');
      } else {
        setBilgi(kart.kararTuru === 'YeniReklamIcerigi'
          ? 'İş emri açıldı — İçerik Stüdyosu sekmesinden takip edebilirsin. Meta\'ya hiçbir şey yazılmadı.'
          : 'Gözden geçirilecek olarak işaretlendi. Meta\'ya hiçbir şey yazılmadı.');
      }
      setKartlar(k => k.filter(x => x.kararId !== kararId));
    } catch (e) {
      setHata(e.response?.data?.hata || e.message || 'Uygulanamadı.');
    } finally { setIslemde(null); }
  };

  const reddet = async (kararId) => {
    setIslemde(kararId); setHata(''); setBilgi('');
    try {
      await kararReddet(kararId);
      setKartlar(k => k.filter(x => x.kararId !== kararId));
      setBilgi('Öneri reddedildi. Geçmişte kalır, sonucu birlikte izleriz.');
    } catch (e) {
      setHata(e.response?.data?.hata || e.message);
    } finally { setIslemde(null); }
  };

  const para = (n) => `${Math.round(Number(n) || 0).toLocaleString('tr-TR')} ₺`;
  const SEVIYE_AD = { Kampanya: 'KAMPANYA', ReklamSeti: 'REKLAM SETİ', Reklam: 'REKLAM' };
  // Ham durum kodları kullanıcıya bir şey söylemiyordu ("Gecersiz" nedir?).
  const DURUM_AD = {
    Uygulandi: 'Uygulandı', Onaylandi: 'Kabul edildi', Reddedildi: 'Reddettin',
    Gecersiz: 'Koşullar değişti', UygulamaHatasi: 'Uygulanamadı', Arsiv: 'Arşiv (eski sistem)',
    Bekliyor: 'Bekliyor',
  };
  const gecmisGorunen = eskiler ? gecmis : gecmis.filter(g => g.yeniSistem);

  // ================================================================================
  // FİLTRE PANELİ (kullanıcı talebi: 2026-10-02)
  //
  // "farklı filtreleme paradigmaları olabilir... belirgin ve dikkat çeken bir tab
  //  yapısında olsun, her filtreleme tekniği birinin içinde olsun"
  //
  // Üç ayrı bakış açısı, üç sekme. Aynı anda yalnız biri geçerli — birbirine karışmasın:
  //   1) İŞ TÜRÜ  — "bugün ne yapmam gerekiyor?"   (en çok kullanılacak olan)
  //   2) YAPI     — "hangi şube / hizmet / seviye?"
  //   3) PARA     — "en çok nerede para var?"
  //
  // Ölçüldü (02.10.2026, 73 kart): para kararı 5 · kreatif işi 43 · not 25.
  // Yani iş türü filtresi tek başına ekranı 73'ten 5'e indiriyor.
  const isTuru = (k) => {
    if (k.metaYazar) return 'para';                        // kabul edince Meta'ya yazılır
    if (k.kararTuru === 'YeniReklamIcerigi' || k.kararTuru === 'YeniOlustur') return 'kreatif';
    return 'not';                                          // gözden geçir / bilgilendirme
  };
  const kampanyaParcasi = (k, i) => {
    const ad = k.kampanyaAdi || (k.seviye === 'Kampanya' ? k.ad : k.ustAd) || '';
    const p = ad.split('|').map(x => x.trim());
    return p.length > i ? p[i] : '';
  };

  const kartListesi = kartlar.map(x => x.kart);
  const benzersiz = (f) => [...new Set(kartListesi.map(f).filter(Boolean))].sort();
  const subeler = benzersiz(k => kampanyaParcasi(k, 0));
  const hizmetler = benzersiz(k => kampanyaParcasi(k, 1));

  const sayim = (f) => kartlar.filter(x => f(x.kart)).length;

  const suzulmus = kartlar.filter(({ kart: k }) => {
    if (fSekme === 'is') return fIs === 'hepsi' || isTuru(k) === fIs;
    if (fSekme === 'yapi') {
      if (fSube !== 'hepsi' && kampanyaParcasi(k, 0) !== fSube) return false;
      if (fHizmet !== 'hepsi' && kampanyaParcasi(k, 1) !== fHizmet) return false;
      if (fSeviye !== 'hepsi' && k.seviye !== fSeviye) return false;
      return true;
    }
    return (Number(k.risktekiPara) || 0) >= fParaEsik;      // 'para' sekmesi
  });

  const siralanmis = fSekme === 'para'
    ? [...suzulmus].sort((a, b) => (Number(b.kart.risktekiPara) || 0) - (Number(a.kart.risktekiPara) || 0))
    : suzulmus;

  const gorunen = hepsiAcik ? siralanmis : siralanmis.slice(0, 5);
  // TOPLAMA YALNIZ GERÇEK RİSK GİRER (kullanıcı yakaladı: 2026-10-02).
  // Hedef açığı ve fırsat tutarları "riskteki para" değildir; hepsini toplamak üst satırı
  // şişiriyordu — kâr eden bir kampanyanın 444.787 ₺'lik hedef açığı da riske sayılıyordu.
  const toplamRisk = siralanmis
    .filter(x => x.kart?.toplamaGirer !== false)
    .reduce((t, x) => t + (Number(x.kart?.risktekiPara) || 0), 0);

  return (
    <div className="kr">
      <div className="kr-serit">
        <div className="kr-sekmeler">
          <button className={sekme === 'bekleyen' ? 'aktif' : ''} onClick={() => setSekme('bekleyen')}>
            Bekleyen Kararlar{kartlar.length > 0 ? ` (${kartlar.length})` : ''}
          </button>
          <button className={sekme === 'gecmis' ? 'aktif' : ''}
                  onClick={() => { setSekme('gecmis'); gecmisYukle(); }}>
            Geçmiş ve Sonuçları
          </button>
        </div>
        <button className="kr-tara" onClick={taramaBaslat} disabled={!!tarama}>
          {tarama ? 'Taranıyor...' : '🔍 Yeniden Tara'}
        </button>
      </div>

      {tarama && (
        <div className="kr-ilerleme">
          <div className="kr-ilerleme-cubuk"><span style={{ width: `${tarama.yuzde}%` }} /></div>
          <small>{tarama.asama}</small>
        </div>
      )}

      {hata && <div className="hata-kutu">{hata}</div>}
      {bilgi && <div className="basari-kutu">{bilgi}</div>}

      {sekme === 'bekleyen' && (
        <>
          {durum === 'yukleniyor' && <div className="loading">Yükleniyor...</div>}

          {durum === 'hazir' && kartlar.length === 0 && (
            <div className="kr-bos">
              <b>Bekleyen karar yok.</b>
              <p>Ya her şey yolunda ya da henüz tarama yapılmadı. Sağ üstten yeniden tarayabilirsin.</p>
            </div>
          )}

          {/* FİLTRE PANELİ — üç paradigma, üç sekme (kullanıcı talebi: 2026-10-02) */}
          {durum === 'hazir' && kartlar.length > 0 && (
            <div className="kr-filtre">
              <div className="kr-filtre-sekmeler">
                <button className={fSekme === 'is' ? 'aktif' : ''} onClick={() => setFSekme('is')}>
                  🎯 İş Türü
                </button>
                <button className={fSekme === 'yapi' ? 'aktif' : ''} onClick={() => setFSekme('yapi')}>
                  🏢 Şube / Hizmet
                </button>
                <button className={fSekme === 'para' ? 'aktif' : ''} onClick={() => setFSekme('para')}>
                  ₺ Paraya Göre
                </button>
              </div>

              <div className="kr-filtre-govde">
                {fSekme === 'is' && (
                  <>
                    <p className="kr-filtre-not">Bugün ne yapman gerektiğine göre ayır.</p>
                    <div className="kr-kovalar">
                      {[
                        { k: 'hepsi', ad: 'Hepsi', alt: 'tüm kartlar', f: () => true },
                        { k: 'para', ad: '💰 Para Kararı', alt: 'kabul edince Meta\'ya yazılır', f: (x) => isTuru(x) === 'para' },
                        { k: 'kreatif', ad: '🎨 Kreatif İşi', alt: 'İçerik Stüdyosu\'na iş emri', f: (x) => isTuru(x) === 'kreatif' },
                        { k: 'not', ad: '📋 İnceleme / Not', alt: 'eylem içermez', f: (x) => isTuru(x) === 'not' },
                      ].map(o => (
                        <button key={o.k} className={fIs === o.k ? 'aktif' : ''} onClick={() => setFIs(o.k)}>
                          <b>{o.ad}</b>
                          <span>{sayim(o.f)}</span>
                          <small>{o.alt}</small>
                        </button>
                      ))}
                    </div>
                  </>
                )}

                {fSekme === 'yapi' && (
                  <>
                    <p className="kr-filtre-not">Şube, hizmet ve seviyeye göre daralt — üçü birlikte çalışır.</p>
                    <div className="kr-filtre-satir">
                      <label>Şube
                        <select value={fSube} onChange={e => setFSube(e.target.value)}>
                          <option value="hepsi">Hepsi</option>
                          {subeler.map(s => <option key={s} value={s}>{s}</option>)}
                        </select>
                      </label>
                      <label>Hizmet
                        <select value={fHizmet} onChange={e => setFHizmet(e.target.value)}>
                          <option value="hepsi">Hepsi</option>
                          {hizmetler.map(h => <option key={h} value={h}>{h}</option>)}
                        </select>
                      </label>
                      <label>Seviye
                        <select value={fSeviye} onChange={e => setFSeviye(e.target.value)}>
                          <option value="hepsi">Hepsi</option>
                          <option value="Kampanya">Kampanya</option>
                          <option value="ReklamSeti">Reklam Seti</option>
                          <option value="Reklam">Reklam</option>
                        </select>
                      </label>
                      <button className="kr-filtre-sifirla"
                              onClick={() => { setFSube('hepsi'); setFHizmet('hepsi'); setFSeviye('hepsi'); }}>
                        temizle
                      </button>
                    </div>
                  </>
                )}

                {fSekme === 'para' && (
                  <>
                    <p className="kr-filtre-not">
                      Risk tutarına göre süz ve büyükten küçüğe sırala. Küçük kartlar gizlenir.
                    </p>
                    <div className="kr-kovalar">
                      {[0, 1000, 5000, 20000].map(e => (
                        <button key={e} className={fParaEsik === e ? 'aktif' : ''} onClick={() => setFParaEsik(e)}>
                          <b>{e === 0 ? 'Hepsi' : `${e.toLocaleString('tr-TR')} ₺ üstü`}</b>
                          <span>{sayim(x => (Number(x.risktekiPara) || 0) >= e)}</span>
                          <small>{e === 0 ? 'sınır yok' : 'bu tutarın altı gizli'}</small>
                        </button>
                      ))}
                    </div>
                  </>
                )}
              </div>

              {siralanmis.length !== kartlar.length && (
                <div className="kr-filtre-ozet">
                  {kartlar.length} karttan <b>{siralanmis.length}</b> tanesi gösteriliyor
                </div>
              )}
            </div>
          )}

          {kartlar.length > 0 && (
            <div className="kr-ozet">
              <b>{kartlar.length} karar bekliyor</b>
              <span>Toplam riskteki para: <b>{para(toplamRisk)}</b></span>
            </div>
          )}

          {gorunen.map(({ kararId, kart }) => (
            <div key={kararId} className={`kr-kart s-${kart.seviye}`}>
              <div className="kr-kart-bas">
                <span className="kr-seviye">{SEVIYE_AD[kart.seviye] || kart.seviye}</span>
                {/* Rakamın NE OLDUĞU yazılır (2026-10-02): her kartta aynı şey değil —
                    kiminde riskteki para, kiminde hedefe uzaklık, kiminde fırsat. */}
                {Number(kart.risktekiPara) > 0 && (
                  <span className="kr-para">
                    {para(kart.risktekiPara)}
                    <small>{kart.tutarEtiketi || 'riskteki para'}</small>
                  </span>
                )}
              </div>

              <h3>{kart.baslik}</h3>
              <p className="kr-ozet-metin">{kart.ozet}</p>

              <div className="kr-oneri">
                <span>ÖNERİM</span>
                <b>{kart.oneri}</b>
              </div>

              {/* Hedefleme değişikliğinde YAZILACAK DEĞER onaydan önce gösterilir — kullanıcı
                  kararı "C" (2026-09-29): sistem yapsın ama körü körüne değil, ne yazacağını
                  göstersin. */}
              {kart.kararTuru === 'HedeflemeDegisikligi' && (
                <div className="kr-degisim">
                  <div><span>Şu an</span><b className="eski">{kart.mevcutGeoOzet}</b></div>
                  <div className="ok">→</div>
                  <div><span>Olacak</span><b className="yeni">{kart.yeniGeoOzet}</b></div>
                </div>
              )}

              {/* SONRAKİ ADIM (kullanıcı talebi: 2026-10-01) — "durdurduktan sonrası içine
                  hiçbir öneride bulunmuyorsun". Durdurmak bir sonuç değil bir hamle;
                  serbest kalan para nereye gidecek, yerine ne konacak? */}
              {kart.sonrakiAdim && (
                <div className="kr-sonraki">
                  <b>{kart.yerineYeniSetTipi ? '↳ Kabul edersen sırayla ne olacak' : '↳ Durdurduktan sonra'}</b>
                  <p>{kart.sonrakiAdim}</p>
                </div>
              )}

              <div className="kr-sonuclar">
                <div><span>Yaparsak</span><b>{kart.yaparsak}</b></div>
                <div><span>Yapmazsak</span><b>{kart.yapmazsak}</b></div>
                <div><span>Risk</span><b>{kart.risk}</b></div>
                <div><span>Güven</span><b>{kart.guven}</b></div>
              </div>

              {acikKanit[kararId] && (
                <div className="kr-kanit">
                  <b>Neye bakarak söylüyorum</b>
                  <ul>{(kart.kanit || []).map((c, i) => <li key={i}>{c}</li>)}</ul>
                  <small>
                    Kural {kart.kural} · hedef: {kart.ad}
                    {kart.ustAd ? ` · bağlı olduğu: ${kart.ustAd}` : ''}
                  </small>
                </div>
              )}

              {/* Düğmeye basmadan ÖNCE ne olacağı yazar (kullanıcı: "KABUL dersem ne oluyor?"). */}
              <div className={`kr-kabul-bilgi${kart.metaYazar ? ' yazar' : ''}`}>
                <span>{kart.metaYazar ? '⚡ Kabul edersen' : '📋 Kabul edersen'}</span>
                {kart.kabulEdilince}
              </div>

              <div className="kr-dugmeler">
                <button className="kr-kabul" disabled={islemde === kararId}
                        onClick={() => kabulEt(kararId, kart)}>✓ Kabul</button>
                <button className="kr-red" disabled={islemde === kararId}
                        onClick={() => reddet(kararId)}>✗ Reddet</button>
                <button className="kr-neden"
                        onClick={() => setAcikKanit(a => ({ ...a, [kararId]: !a[kararId] }))}>
                  {acikKanit[kararId] ? 'Kanıtı gizle' : '? Neden böyle diyorsun'}
                </button>
              </div>
            </div>
          ))}

          {kartlar.length > 5 && (
            <button className="kr-daha" onClick={() => setHepsiAcik(h => !h)}>
              {hepsiAcik ? 'Sadece en önemli 5 tanesini göster' : `Diğer ${kartlar.length - 5} öneriyi de göster`}
            </button>
          )}
        </>
      )}

      {sekme === 'gecmis' && (
        <div className="kr-gecmis">
          <p className="kr-not">
            Verdiğin kararlar ve ne olduğu. Sistemin yanıldığı kararlar da burada durur —
            körü körüne güvenmen istenmiyor. Reddettiğin bir öneriyi buradan geri çağırabilirsin.
          </p>

          {/* Ağustos 2026'daki ESKİ sistemden kalan kayıtlar varsayılan olarak gizli: kullanıcı
              bunları kendi kararları sanıyordu (soru: 2026-09-29 "ben henüz bir karar vermedim
              ama Geçmiş listesi dolu, nerden geldi bunlar?"). */}
          {gecmis.some(g => !g.yeniSistem) && (
            <label className="kr-eski-secim">
              <input type="checkbox" checked={eskiler} onChange={e => setEskiler(e.target.checked)} />
              Ağustos'taki eski sistemden kalan {gecmis.filter(g => !g.yeniSistem).length} kaydı da göster
            </label>
          )}

          {gecmisGorunen.length === 0 && (
            <div className="kr-bos">
              <b>Henüz senin verdiğin bir karar yok.</b>
              <p>Bir öneriyi kabul ya da reddettiğinde burada görünecek.</p>
            </div>
          )}

          {gecmisGorunen.length > 0 && (
          <table className="kr-tablo">
            <thead>
              <tr>
                <th>Tarih</th><th>Seviye</th><th>Karar</th><th>Konu</th>
                <th className="sag">Riskteki para</th><th>Durum</th><th />
              </tr>
            </thead>
            <tbody>
              {gecmisGorunen.map(g => (
                <tr key={g.kararId} className={g.yeniSistem ? '' : 'kr-eski'}>
                  <td>{new Date(g.kararZamani || g.olusma).toLocaleDateString('tr-TR')}</td>
                  <td>{SEVIYE_AD[g.seviye] || g.seviye}</td>
                  <td>{g.baslik}</td>
                  <td>{g.hedef}</td>
                  <td className="sag">{g.risktekiPara ? para(g.risktekiPara) : ''}</td>
                  <td className={`kr-durum d-${g.durum}`}>
                    {DURUM_AD[g.durum] || g.durum}{g.hata ? ` · ${g.hata}` : ''}
                  </td>
                  <td className="kr-gecmis-islem">
                    {g.geriGetirilebilir && (
                      <button className="kr-geri" disabled={islemde === g.kararId}
                              onClick={() => geriGetir(g.kararId)}
                              title="Bu öneriyi karar kutusuna geri getir">↩ Geri getir</button>
                    )}
                    {/* ARŞİVDEN SİL (kullanıcı talebi: 2026-10-02) — "kendi inisiyatifimle
                        silme imkanı da tanı". Onay soruluyor: silme geri alınamaz. */}
                    <button className="kr-sil" disabled={islemde === g.kararId}
                            onClick={() => arsivdenSil(g.kararId)}
                            title="Bu kaydı kalıcı olarak sil">✕ Sil</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          )}
        </div>
      )}
    </div>
  );
}
